let NewsService = function (Restangular) {
  const News = Restangular.all('admin/news_item');

  let count = (query) => {
    return News.customGET('count', query);
  } 

  let save = (newsItem) => {
    if (newsItem.save) {
        return newsItem.save();
    } else {
        return News.post(newsItem);
    }
  }

  let index = (query) => {
    query = query || {};
    query.deleted_at = 'null';
    return News.getList(query);
  }

  let load = (query) => {
    query.deleted_at = 'null';
    return new Promise((resolve, reject) => {
        count(query)
        .then(response => {
            let count = response[0];
            index(query)
            .then(data => {
                resolve({count, data});
            })
            .catch(err => {
                reject(err);
            });
        })
        .catch(err => {
            reject(err);
        });
    });
  }

  let show = (id) => {
    return News.get(id);
  }

  let destroy = (newsItem) => {
    newsItem.deleted_at = moment();
    return News.customDELETE(newsItem.id);
  }

  return { index, load, save, show, destroy } ;
};

NewsService.$inject = ['Restangular'];

export default NewsService;



// WEBPACK FOOTER //
// ./client/app/components/news/news.service.js